import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { LINK_ECOMMERCE_TERMS } from '../../../brands/default/links';
import { formatCurrency, symbolFromCurrency } from '../../../helpers/currency';
import { dateConvertTimestampToDoMmmyyyy } from '../../../helpers/date';

const VipSubscriptionMessage = ({
  isBenefitCard = false,
  renewalDate,
  vipCurrency,
  vipMonths,
  vipPrice,
  quarterlySubEnabled = false,
  vipQuarterlyPrice,
  vipComplianceText,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const [renewalDateString, setRenewalDateString] = useState('');
  const [vipPriceString, setVipPriceString] = useState('');
  const [vipOneMonthPriceString, setVipOneMonthPriceString] = useState('');
  const [periodText, setPeriodText] = useState('');
  const currencySymbol = symbolFromCurrency(vipCurrency);

  useEffect(() => {
    if (renewalDate) {
      setRenewalDateString(dateConvertTimestampToDoMmmyyyy(renewalDate));
    }
    if (quarterlySubEnabled) {
      setPeriodText('for 3 months');
    } else if (vipMonths) {
      setPeriodText('for ' + vipMonths + ' months');
      if (vipMonths === 12) {
        setPeriodText('for one year');
      }
      if (vipMonths === 6) {
        setPeriodText('for six months');
      }
    }

    if (vipPrice && !quarterlySubEnabled) {
      setVipPriceString(currencySymbol + vipPrice);
    } else if (quarterlySubEnabled && vipQuarterlyPrice) {
      setVipPriceString(currencySymbol + vipQuarterlyPrice);
    }
    if (vipPrice && vipMonths) {
      // work out price per month
      setVipOneMonthPriceString(
        formatCurrency(
          vipCurrency,
          vipPrice / vipMonths ?? '0',
          false,
          false,
          false,
        ),
      );
    }
  }, [vipPrice, vipQuarterlyPrice, quarterlySubEnabled, renewalDate]);

  if (
    !renewalDateString ||
    !vipPriceString ||
    !periodText ||
    !vipOneMonthPriceString
  )
    return null;

  return (
    <>
      {vipComplianceText ? (
        <div className="vip-message">
          {vipComplianceText} See full{' '}
          <a
            className="link"
            href={LINK_ECOMMERCE_TERMS.href + '#vip'}
            rel="noreferrer"
            target="_blank"
          >
            T&Cs
          </a>{' '}
          here.
        </div>
      ) : (
        <div className="vip-message">
          Your VIP membership will auto-renew at {vipPriceString} on{' '}
          {renewalDateString} {periodText} ({vipOneMonthPriceString} per month)
          and will auto-renew every {quarterlySubEnabled ? '3' : vipMonths}{' '}
          months until you cancel. We may change the price on renewal and will
          notify you in advance if so. We will send you reminders 14 and 5 days
          before renewal. If you change your mind, you can cancel your VIP
          subscription within 14 days of purchase and within 14 days of any
          auto-renewal. To cancel at any time, visit &#34;My Subscriptions&#34;
          from your My Account page. See full{' '}
          <a
            className="link"
            href={
              LINK_ECOMMERCE_TERMS[process.env.NEXT_PUBLIC_SITE].href + '#vip'
            }
            rel="noreferrer"
            target="_blank"
          >
            T&Cs
          </a>{' '}
          here.
        </div>
      )}
      <style jsx>{`
        .vip-message {
          font-size: 11px;
          margin: ${isBenefitCard ? '10px 0 5px 0' : '10px 5px 5px 5px'};
          text-align: justify;
        }
        .link {
          color: inherit;
          text-decoration: underline;
        }
      `}</style>
    </>
  );
};

export default VipSubscriptionMessage;

VipSubscriptionMessage.propTypes = {
  isBenefitCard: PropTypes.bool,
  quarterlySubEnabled: PropTypes.bool,
  renewalDate: PropTypes.number,
  vipComplianceText: PropTypes.string,
  vipCurrency: PropTypes.string,
  vipMonths: PropTypes.number,
  vipPrice: PropTypes.number,
  vipQuarterlyPrice: PropTypes.number,
};
